// extracted by mini-css-extract-plugin
export default {"maindiv":"MainProductGroupCard_maindiv__srqTM","main_count_group":"MainProductGroupCard_main_count_group__1BAh1"};